export var DATE_PICKER_CHANGE_REASON = Object.freeze({
  MANUAL_INPUT: 'manual input',
  DROPDOWN_CLICK: 'dropdown click',
  DROPDOWN_KEYBOARD: 'dropdown keyboard'
});